"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
class ControllerCompositionGisAreas {
    constructor(dataSynthetic) {
        this.loading = false;
        this.dataSynthetic = dataSynthetic;
    }
    async createSyntheticRate() {
        const data = this.dataSynthetic;
        this.loading = true;
        try {
            const response = await axios_1.default.post('/data/results/rate/compositor', data);
        }
        catch (error) {
            console.log(error);
        }
        setTimeout(() => {
            this.loading = false;
        }, 1000);
    }
    get isLoading() {
        return this.loading;
    }
}
exports.default = ControllerCompositionGisAreas;
